export default "__VITE_ASSET__Drl7Eb$n__"